import {BaseModel} from '../../base/models/base-model.model';
import {Management} from '../../shared/DTO/management';
import {DraftState} from '../../shared/DTO/draftState';
import * as moment from 'moment';
import {DraftOperator} from "../../shared/DTO/draftOperator";
import {DraftOperatorModel} from "./draft-operator.model";

export class DraftModel extends BaseModel {
  private _articleTypes: Array<string>;
  private _creationDate?: moment.Moment;
  private _expirationDate?: moment.Moment;
  private _management: Management;
  private _modifyDate?: moment.Moment;
  private _name: string;
  private _operator?: DraftOperatorModel;
  private _processId: string;
  private _reserved?: boolean;
  private _state?: DraftState;
  private _unit: string;
  private _deleteMode: boolean;

  constructor(articleTypes?: Array<string>, creationDate?: moment.Moment, expirationDate?: moment.Moment, management?: Management, modifyDate?: moment.Moment, name?: string, operator?: DraftOperatorModel, processId?: string, reserved?: boolean, state?: DraftState, unit?: string, deleteMode?:boolean) {
    super();
    this._articleTypes = articleTypes;
    this._creationDate = creationDate;
    this._expirationDate = expirationDate;
    this._management = management;
    this._modifyDate = modifyDate;
    this._name = name;
    this._operator = operator;
    this._processId = processId;
    this._reserved = reserved;
    this._state = state;
    this._unit = unit;
    this._deleteMode = deleteMode;
  }

  get deleteMode(): boolean {
    return this._deleteMode;
  }

  set deleteMode(value: boolean) {
    this._deleteMode = value;
  }

  get articleTypes(): Array<string> {
    return this._articleTypes;
  }

  set articleTypes(value: Array<string>) {
    this._articleTypes = value;
  }

  get creationDate(): moment.Moment {
    return this._creationDate;
  }

  set creationDate(value: moment.Moment) {
    this._creationDate = value;
  }

  get expirationDate(): moment.Moment {
    return this._expirationDate;
  }

  set expirationDate(value: moment.Moment) {
    this._expirationDate = value;
  }

  get management(): Management {
    return this._management;
  }

  set management(value: Management) {
    this._management = value;
  }

  get modifyDate(): moment.Moment {
    return this._modifyDate;
  }

  set modifyDate(value: moment.Moment) {
    this._modifyDate = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get operator(): DraftOperatorModel {
    return this._operator;
  }

  set operator(value: DraftOperatorModel) {
    this._operator = value;
  }

  get processId(): string {
    return this._processId;
  }

  set processId(value: string) {
    this._processId = value;
  }

  get reserved(): boolean {
    return this._reserved;
  }

  set reserved(value: boolean) {
    this._reserved = value;
  }

  get state(): DraftState {
    return this._state;
  }

  set state(value: DraftState) {
    this._state = value;
  }

  get unit(): string {
    return this._unit;
  }

  set unit(value: string) {
    this._unit = value;
  }
}
